(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-GRQ"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      var videos = document.querySelectorAll('video');
      videos.forEach(function(video) {
        video.play().catch(function(error) {
          console.error('Error attempting to play video:', error);
        });
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    


  document.addEventListener('DOMContentLoaded', function() {
      var videos = document.querySelectorAll('video');
      videos.forEach(function(video) {
        video.play().catch(function(error) {
          console.error('Error attempting to play video:', error);
        });
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-it"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabItems = document.querySelectorAll('.rb-tabs-item');
    const tabContentItems = document.querySelectorAll('.rb-tabs-content-item');

  
    tabItems.forEach((tabItem, index) => {
        tabItem.addEventListener('click', () => {
         
            tabItems.forEach(item => item.classList.remove('active-tab--title'));
            tabContentItems.forEach(item => item.classList.remove('active-tab--content'));

           
            tabItem.classList.add('active-tab--title');
          
            tabContentItems[index].classList.add('active-tab--content');

        
            if (index === 0) {
            
                document.querySelectorAll('.containers-container').forEach(item => {
                    item.style.display = 'flex';
                });
           
                document.querySelector('.containers-container-product-information').style.display = 'none';
            }
          
            else if (index === 1) {
            
                document.querySelectorAll('.containers-container').forEach(item => {
                    item.style.display = 'none';
                });
               
                document.querySelector('.containers-container-product-information').style.display = 'block';
            }
        });
    });
});
  
  } catch(e) { console.error(e); }
})();
})();
